export default __webpack_public_path__ + "static/media/Group 253.a8aa2f99.svg";